import type { SeatCandidate } from '@anjabom/core';

export interface SharedSeat {
  venueId: string;
  layoutVersionId: string;
  sectionCode: string;
  rowLabel: string;
  seatNumber: number;
}

const MAX_FIELD_LENGTH = 160;

export function seatSharePath(candidate: SeatCandidate): string {
  const key = [candidate.venueId, candidate.layoutVersionId, candidate.sectionCode, candidate.rowLabel, candidate.seatNumber].join(':');
  return `/seat/${encodeURIComponent(key)}`;
}

export function parseSharedSeatKey(key: string | undefined): SharedSeat | null {
  const parts = key?.split(':') ?? [];
  if (parts.length !== 5) return null;
  const venueId = bounded(parts[0] ?? null);
  const layoutVersionId = bounded(parts[1] ?? null);
  const sectionCode = bounded(parts[2] ?? null);
  const rowLabel = bounded(parts[3] ?? null);
  const seatNumber = Number(parts[4]);

  if (!venueId || !layoutVersionId || !sectionCode || !rowLabel) return null;
  if (!Number.isInteger(seatNumber) || seatNumber < 1 || seatNumber > 9999) return null;

  return { venueId, layoutVersionId, sectionCode, rowLabel, seatNumber };
}

function bounded(value: string | null): string | null {
  const normalized = value?.trim() ?? '';
  return normalized && normalized.length <= MAX_FIELD_LENGTH ? normalized : null;
}
